
export const RPE_EMOJI = ['😴','😌','🙂','🙂','😐','😕','😣','😖','🥵','🤮'];
export const rpeEmoji = (rpe) => (rpe >= 1 && rpe <= 10 ? RPE_EMOJI[rpe - 1] : null);